<template>
    <div class="container-fluid container-full-image">
        <div class="row">
            <div class="col-12">
                <img :src="utils.image(value, 1440, 518)" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import utils from '@/utils'

export default {
    name: 'ImageFull',
    props:['value'],
    data() {
        return {
            utils:utils
        }
    }
}
</script>